import React from 'react';
import { Link } from 'react-router-dom';
import css from './not-found.module.scss';
import { GENERAL } from 'src/constants/routes';
import { ReactComponent as NotFoundPlaceholder } from 'src/assets/not-found.svg';
import { useMetaContext } from 'src/hooks/meta-context';

const meta = {
  title: "Помилка 404 - сторінку не знайдено | На зв'язку",
  description:
    'Сторінку не знайдено. Можливо, вона була видалена або переміщена. Перевірте правильність адреси або поверніться на головну сторінку.'
};

export default function NotFound() {
  const { updateMetaInfo } = useMetaContext();
  updateMetaInfo(meta);

  return (
    <main className={css.container}>
      <div className={css.message}>
        <h3>Отакої! Сторінка, яку Ви намагаєтесь знайти, недоступна</h3>
        <h4>
          Будь ласка переконайтесь, що URL введено правильно або перейдіть на{' '}
          <Link className={css.hyperlink} to={GENERAL.path}>
            Домашню сторінку
          </Link>
        </h4>
        <NotFoundPlaceholder />
      </div>
    </main>
  );
}
